export function isValidEmail(email) {
  const re = /\S+@\S+\.\S+/;

  return re.test(email) || "Invalid email";
}

export const rules = [isValidEmail];
